<template>
	<div v-if="context">
		<nk-wrapper spacing="lg">
			<nk-nav
				class="navigation-wegweiser"
				aria-label="Anfangsbuchstaben"
				variant="abc"
			>
				<nk-nav-item
					v-for="(alpha, alphaIndex) in context"
					:key="alphaIndex"
					:link="getAbcUrl(alpha.detailURL)"
				>
					{{ alpha.titel.charAt(0) }}
				</nk-nav-item>
			</nk-nav>
		</nk-wrapper>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateWegweiserAbc',

	mixins: [TemplatesDefault],

	methods: {
		getAbcUrl(route) {
			// Return the route without the last part of the path, if the last part is a slash, remove it as well
			return route.replace(/\/([a-z0-9_-]*[/]?)$/, '');
		},
	},
};
</script>
